(function() { window.GUID_ccb81265_9e05_4534_93fd_3c013cf592bd = { getGuid: function() { return "ccb81265-9e05-4534-93fd-3c013cf592bd"; } }; })();
CompuSport.DOM.body.on('click', '.SetWinner', function (e) {
    var data = {
        elementToRefresh: 'ScheduleItem',
        encounterRowId: $(this).data('encounterrowid')
    };
    ShowSchedulesScorePopup(data);
});
function ShowSchedulesScorePopup(data) {
    CompuSport.Ajax.Get(CSParameters.RUrl + 'Scores/CheckIsNewScoreSheet/' + CSParameters.SportEventId, data, function (response) {
        if (response.isNewScoreSheet) {
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'ScorePopup',
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                //UpdateChart(response, true);
            };
        }
        else {
            /*
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "ScorePopup",
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                UpdateChart(response, true);
            }
            */
            ShowFormPopup(CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId, data, null, function (response, pressedButton) {
                if (pressedButton != "EnterKey") {
                    //UpdateChart(response, true);
                    $(this).dialog('close');
                }
            });
        }
    });
}

//# sourceMappingURL=Schedules.js.map
